import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import GraphFuncs from './GraphFuncs';
import moment from 'moment';
import * as XLSX from 'xlsx';

const GlobalFuncs = {

  cleanString: (value) => {
    let temp = value.replaceAll(/[^A-Za-z0-9-]/g, '').replaceAll('/', '');
    return temp;
  },

  ScrollToTop: () => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);

    return null;
  },
  formatDate: (date, format, compensate = false) => {
    if (compensate) date.setDate(date.getDate() + 1)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    let monthDict = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    format = format.replace('YYYY', year);
    format = format.replace('YY', year - 2000);
    format = format.replace('MM', month);
    format = format.replace('Mm', monthDict[month - 1]);
    format = format.replace('DD', day);
    format = format.replace('HH', hours);
    format = format.replace('mm', minutes);
    format = format.replace('ss', seconds);
    return format;
  },
  getDateFromStringUTC: (date) => {
    return Date.UTC(date.split("-")[0] - 1, date.split("-")[1] - 1, date.split("-")[2])
  },
  get15MinRange: (dateString) => {
    const [year, month, day, hours, minutes, seconds] = dateString.split(/[- :]/);
    const currentDate = new Date(year, month - 1, day, hours, minutes, seconds);
    currentDate.setMinutes(currentDate.getMinutes() - 15);
    return `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')} ${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')}:${currentDate.getSeconds().toString().padStart(2, '0')}`;

  },
  getApplicableDates: (start, end, months, days, frequency, toDate, source, impact) => {
    if (!frequency || (frequency === 'Monthly' && !months) || (frequency === 'Daily' && (!months || !days))) return 0
    let cost = 0
    let co = 0
    let count = 0
    months = months.split(',').map(e => parseInt(e))
    var lastDay = moment();
    if (end && (!toDate || moment() > moment(end))) lastDay = end
    if (frequency === 'Daily') {
      days = days.split(',').map(e => parseInt(e))
      let numDays = GraphFuncs.getDifferenceInDays(start, lastDay)
      for (let day = 0; day < numDays; day++) {
        let tempDay = moment(start).add(day, 'days')
        if (days.includes(tempDay.day()) && months.includes(tempDay.month())) {
          count += impact.reduction
          for (let value of source.cost_model) {
            let typeDict = {
              kwh: (value.subsequent_kwh_price + value.carbon_charge),
              kva: value.subsequent_kva_price,
              water: ((value.consumption_rate / 1000) + (((value.consumption_rate / 1000) * value.sewage_ratio / 100) * (value.sewage_rate / 1000))),
              gas: ((value.consumption_rate + value.carbon_charge) / 35.314)
            }
            let valueDate = moment(value.start_date, "YYYY-MM-DD HH:mm:ss");
            if (tempDay.isSameOrAfter(valueDate)) {
              let tempCost = impact.reduction * typeDict[impact.type]
              tempCost = tempCost + (tempCost * value.gs_tax / 100) + (tempCost * value.ps_tax / 100)
              cost += tempCost
              break
            }
          }
          if (source.co_model) {
            for (let value of source.co_model) {
              let typeDict = {
                kwh: value.factor / 1000,
                gas: value.factor / 35314
              }
              let valueDate = moment(value.start_date, "YYYY-MM-DD HH:mm:ss");
              if (tempDay.isSameOrAfter(valueDate)) {
                let tempCost = impact.reduction * typeDict[impact.type]
                co += tempCost
                break
              }
            }
          }
        }
      }
    } else {
      let numMonths = GraphFuncs.getDifferenceInMonths(start, lastDay)
      for (let month = 0; month < numMonths; month++) {
        let tempMonth = moment(start)
        tempMonth.add(month, 'months')
        if (months.includes(tempMonth.month())) {
          count += impact.reduction
          for (let value of source.cost_model) {
            let typeDict = {
              kwh: (value.subsequent_kwh_price + value.carbon_charge),
              kva: value.subsequent_kva_price,
              water: ((value.consumption_rate / 1000) + (((value.consumption_rate / 1000) * value.sewage_ratio / 100) * (value.sewage_rate / 1000))),
              gas: ((value.consumption_rate + value.carbon_charge) / 35.314)
            }
            if (tempMonth >= moment(value.start_date)) {
              let tempCost = impact.reduction * typeDict[impact.type]
              tempCost = (tempCost + (tempCost * value.gs_tax / 100) + (tempCost * value.ps_tax / 100))
              cost += tempCost
              break
            }
          }
          if (source.co_model) {
            for (let value of source.co_model) {
              let typeDict = {
                kwh: value.factor / 1000,
                gas: value.factor / 35314
              }
              if (tempMonth >= moment(value.start_date)) {
                let tempCost = impact.reduction * typeDict[impact.type]
                co += tempCost
                break
              }
            }
          }
        }
      }
    }
    return { cost: cost, co: co, reduction: count };
  },
  getCalculatedAlertValues: (data, context, triggeredRange = null, closedRange = null) => {
    data = JSON.parse(JSON.stringify(data))
    data = data.filter(group => {
      group.status = 'Set'
      group.equipment = []
      group.lastTriggered = null
      group.lastTriggeredSince = null
      group.lastAssignedTo = null
      group.isSubscribed = group.subscribers && !!group.subscribers.find(e => e.subscriber === context.getUserInfo?.username)
      group.triggerCount = 0
      group.openCount = 0
      group.daysOpen = 0
      group.equipmentFrequency = {}

      let activityTriggerDict = {}
      group.logs = group.logs.filter(log => {
        if (triggeredRange && triggeredRange.length > 0 && !moment(log.last_timestamp).isBetween(triggeredRange[0], triggeredRange[1])) return false
        if (closedRange && closedRange.length > 0 && (!log.closed_at || !moment(log.closed_at).isBetween(closedRange[0], closedRange[1]))) return false

        let tempClosed = log.closed_at ? moment(log.closed_at) : moment()
        log.lastAssignedTo = null
        log.triggeredSince = tempClosed.diff(moment(log.first_timestamp), 'hours')
        log.daysOpen = tempClosed.diff(moment(log.first_timestamp), 'hours')
        log.alert_group_id = group.id
        log.channel_type = group.channel_type
        log.severity = group.severity
        log.type_name = group.type_name
        log.name = group.name
        log.group_parameters = JSON.parse(JSON.stringify(group.parameters))
        group.triggerCount++
        if (!log.closed_at) group.openCount++
        group.daysOpen += log.daysOpen

        let tempDate = null
        for (let workflow of log.workflow) {
          if (tempDate === null || moment(workflow.assigned_at).isAfter(tempDate)) {
            tempDate = moment(workflow.assigned_at)
            log.lastAssignedTo = workflow.assignee_name
            group.lastAssignedTo = workflow.assignee_name
          }
        }

        if (group.lastTriggered === null || moment(log.last_timestamp).isAfter(group.lastTriggered)) {
          group.lastTriggered = moment(log.last_timestamp)
          group.lastTriggeredSince = moment().diff(moment(log.last_timestamp), 'hours')
        }
        if (group.status !== "Open") {
          if (!log.closed_at && !log.lastAssignedTo) {
            group.status = "Open";
          } else if (group.status !== "Assigned" && !log.closed_at && log.lastAssignedTo) {
            group.status = "Assigned";
          } else {
            group.status = "Set";
          }
        }
        activityTriggerDict[log.alert_activity_id] = activityTriggerDict[log.alert_activity_id] || { lastTriggered: moment('1900-01-01'), lastTriggeredSince: null, status: "Set", triggerCount: 0 }
        if (moment(log.last_timestamp).isAfter(moment(activityTriggerDict[log.alert_activity_id].lastTriggered))) activityTriggerDict[log.alert_activity_id] = {
          lastTriggered: log.last_timestamp,
          lastTriggeredSince: log.triggeredSince,
          triggerCount: activityTriggerDict[log.alert_activity_id].triggerCount++
        }

        if (activityTriggerDict[log.alert_activity_id].status !== "Open") {
          if (!log.closed_at && !log.lastAssignedTo) {
            activityTriggerDict[log.alert_activity_id].status = "Open";
          } else if (activityTriggerDict[log.alert_activity_id].status !== "Assigned" && !log.closed_at && log.lastAssignedTo) {
            activityTriggerDict[log.alert_activity_id].status = "Assigned";
          } else {
            activityTriggerDict[log.alert_activity_id].status = "Set";
          }
        }
        let key = log.point_name
        group.equipmentFrequency[key] = group.equipmentFrequency[key] || 0
        group.equipmentFrequency[key]++

        return true
      })

      if (triggeredRange && triggeredRange.length > 0 && group.logs.length === 0) return false
      if (closedRange && closedRange.length > 0 && group.logs.length === 0) return false

      group.activities.forEach(e => {
        e.group_parameters = JSON.parse(JSON.stringify(group.parameters))
        e.channel_type = group.channel_type
        e.severity = group.severity
        e.type = group.type
        e.name = group.name
        e.type_name = group.type_name
        group.equipment.push(e.point_name)
        const { lastTriggered = null, lastTriggeredSince = 0, status = "Set", triggerCount = 0 } = activityTriggerDict[e.id] || {};
        Object.assign(e, { lastTriggered, lastTriggeredSince, status, triggerCount });
      });

      return true
    })
    return data
  },
  getCalculatedMaintenanceValues: (context, data, equipmentRuntime) => {

    const sumRuntime = (channelId, from, to) => {
      let total = 0;
      let days = 0
      const cursor = from.clone();
      while (cursor.isSameOrBefore(to)) {
        const dayKey = cursor.format('YYYY-MM-DD');
        total += equipmentRuntime[channelId]?.[dayKey] ?? 0;
        days += 1
        cursor.add(1, 'days');
      }
      return { total: total, days: days };
    };

    data = JSON.parse(JSON.stringify(data))
    for (let group of data) {
      group.lastActionDate = null
      group.equipment = []
      group.threshold = null
      group.tolerance = null
      group.dueIn = null
      group.performedBy = null
      group.isSubscribed = group.subscribers && !!group.subscribers.find(e => e.subscriber === context.getUserInfo?.username)
      group.percent = null

      group.logs.sort((a, b) => {
        return moment(a.completed_date).diff(moment(b.completed_date));
      });

      group.activities.forEach(e => {
        e.lastActionDate = null
        e.performedBy = null
      })

      let currentDate = {}
      for (let log of group.logs) {
        log.runtime = 0
        log.daysOverdue = 0
        log.actualTimebase = ''
        log.onTime = true
        log.group_id = group.id
        let activity = group.activities.find(e => e.id === log.activity_id)
        if (!activity) continue
        currentDate[activity.id] = currentDate[activity.id] || moment("2022-01-01")
        log.channel_name = activity.channel_name
        log.channel_id = activity.channel_id
        log.type = group.type
        activity.lastActionDate = log.completed_date ? log.completed_date.split("T")[0] : null
        activity.performedBy = log.performed_by

        if (!group.lastActionDate || moment(group.lastActionDate) < moment(activity.lastActionDate)) {
          group.lastActionDate = activity.lastActionDate
          group.performedBy = activity.performedBy
        }

        const startDate = currentDate[activity.id];
        const endDate = moment(log.completed_date);
        const daysDiff = endDate.diff(startDate, 'days');
        switch (activity.timebase) {
          case 'runtime': {
            const runtime = sumRuntime(activity.channel_id, startDate, endDate)
            log.runtime = runtime.total;
            log.percentHours = log.runtime / log.threshold_hours;
            log.actualTimebase = 'runtime'
            currentDate[activity.id].add(runtime.days, 'days')
            break;
          }
          case 'days': {
            log.runtime = daysDiff;
            log.percentDays = log.runtime / log.threshold_days;
            log.actualTimebase = 'days'
            currentDate[activity.id] = endDate
            break;
          }
          default: {
            const runtime = sumRuntime(activity.channel_id, startDate, endDate);
            log.percentHours = runtime.runtime / log.threshold_hours
            log.percentDays = daysDiff / log.threshold_days
            if (log.percentHours < log.percentDays) {
              log.runtime = runtime.runtime
              log.percent = log.percentHours
              log.actualTimebase = 'runtime'
              currentDate[activity.id].add(runtime.days, 'days')
              if (log.runtime > (log.threshold_hours + log.tolerance_hours)) {
                log.onTime = false
                log.daysOverdue = log.runtime - (log.threshold_hours + log.tolerance_hours)
              }
            }
            else {
              log.runtime = daysDiff
              log.percent = log.percentDays
              log.actualTimebase = 'days'
              currentDate[activity.id] = endDate
              if (log.runtime > (log.threshold_days + log.tolerance_days)) {
                log.onTime = false
                log.daysOverdue = log.runtime - (log.threshold_days + log.tolerance_days)
              }
            }
            break;
          }
        }

      }

      for (let activity of group.activities) {
        group.equipment.push(activity.channel_name)
        activity.type = group.type
        activity.actualTimebase = ''
        
        
        const startDate = activity.lastActionDate ? moment(activity.lastActionDate) : moment('2022-01-01');
        const endDate = moment()
        const daysDiff = endDate.diff(startDate, 'days');
        
        switch (activity.timebase) {
          case 'runtime': {
            const { runtime } = sumRuntime(activity.channel_id, startDate, endDate);
            activity.dueIn = activity.threshold_hours - runtime
            activity.dueInHours = activity.dueIn
            activity.runtime = runtime
            activity.actualTimebase = 'runtime'
            activity.threshold = activity.threshold_hours
            activity.tolerance = activity.tolerance_hours
            break;
          }
          case 'days': {
            activity.dueIn = activity.threshold_days - daysDiff
            activity.dueInDays = activity.dueIn
            activity.runtime = daysDiff
            activity.actualTimebase = 'days'
            activity.threshold = activity.threshold_days
            activity.tolerance = activity.tolerance_days
            break;
          }
          default: {
            const { runtime } = sumRuntime(activity.channel_id, startDate, endDate);
            const percentHours = runtime / activity.threshold_hours
            const percentDays = daysDiff / activity.threshold_days
            activity.dueIn = percentHours < percentDays ? activity.threshold_hours : activity.threshold_days
            if (percentHours < percentDays) {
              activity.dueIn -= runtime
              activity.dueInHours = activity.dueIn
              activity.runtime += runtime
              activity.actualTimebase = 'runtime'
              activity.threshold = activity.threshold_hours
              activity.tolerance = activity.tolerance_hours
            }
            else {
              activity.dueIn -= daysDiff
              activity.dueInDays = activity.dueIn
              activity.runtime = daysDiff
              activity.actualTimebase = 'days'
              activity.threshold = activity.threshold_days
              activity.tolerance = activity.tolerance_days
            }
            break;
          }
        }

        activity.percent = activity.runtime / activity.threshold
        activity.percentHours = activity.runtimeHours / activity.threshold_hours
        activity.percentDays = activity.runtimeDays / activity.threshold_days
        activity.currentStatus = activity.dueIn > (activity.tolerance) ? 'Set' :
          activity.dueIn <= (activity.tolerance) && activity.dueIn >= 0 ? 'Upcoming' :
            activity.dueIn < 0 && activity.dueIn >= (- activity.tolerance) ? 'Due' :
              'Overdue'

        if (group.percent === null || activity.percent < group.percent) {
          group.threshold = activity.threshold
          group.tolerance = activity.tolerance
          group.dueIn = activity.dueIn
          group.timebase = activity.actualTimebase ? activity.actualTimebase : activity.timebase
          group.percent = activity.percent
          group.currentStatus = activity.currentStatus
        }
      }
    }
    return data
  },
  getCalculatedValues: async (getBuildingInfo, data, range = null) => {
    let lastYear = moment().subtract(1, 'year');

    const typeDict = { kwh: "e_sources", kva: "e_sources", gas: "g_sources", water: "w_sources" }
    for (let activity of data) {
      activity.startDate = null
      activity.cap_ex = false
      activity.greenwave = activity.greenwave ? true : false
      activity.endDate = null
      activity.kwhToDate = 0
      activity.kwhYear = 0
      activity.kwhTotal = 0
      activity.kwhPriceToDate = 0
      activity.kwhPriceYear = 0
      activity.kvaToDate = 0
      activity.kvaYear = 0
      activity.kvaTotal = 0
      activity.kvaPriceToDate = 0
      activity.kvaPriceYear = 0
      activity.gasToDate = 0
      activity.gasYear = 0
      activity.gasTotal = 0
      activity.waterToDate = 0
      activity.waterTotal = 0
      activity.waterYear = 0
      activity.coToDate = 0
      activity.coYear = 0
      activity.gasPriceToDate = 0
      activity.gasPriceYear = 0
      activity.waterPriceToDate = 0
      activity.waterPriceYear = 0
      activity.savings = 0

      let skipEnd = false
      for (let impact of activity.impacts) {


        let tempStart = null
        if (impact.cap_ex) activity.cap_ex = true
        if (!impact.start_date) continue
        tempStart = new Date(impact.start_date)
        if (activity.startDate !== null) {
          if (new Date(impact.start_date) < new Date(activity.startDate)) activity.startDate = impact.start_date.split("T")[0]
        } else {
          activity.startDate = impact.start_date.split("T")[0]
        }

        if (impact.end_date === null) {
          activity.endDate = null
          skipEnd = true
        } else if (!skipEnd) {
          if (activity.endDate !== null) {
            if (new Date(impact.end_date) > new Date(activity.endDate)) activity.endDate = impact.end_date.split("T")[0]
          } else if (impact.end_date !== null) {
            activity.endDate = impact.end_date.split("T")[0]
          }
        }
        let formattedStart = impact.start_date.split("T")[0]
        let rangeStart = (range && moment(impact.start_date.split("T")[0]) < moment(range[0])) ? moment(range[0]).format('YYYY-MM-DD') : impact.start_date.split("T")[0]
        let rangeEnd = null
        if (range) {
          if (impact.end_date) {
            if (moment(impact.end_date.split("T")[0]) > moment(range[1])) {
              rangeEnd = moment(range[1]).format('YYYY-MM-DD')
            } else {
              rangeEnd = impact.end_date.split("T")[0]
            }
          } else {
            rangeEnd = moment(range[1]).format('YYYY-MM-DD')
          }
        } else {
          if (impact.end_date) {
            rangeEnd = impact.end_date.split("T")[0]
          } else {
            rangeEnd = moment().format('YYYY-MM-DD')
          }
        }

        let today_str = moment().format('YYYY-MM-DD')
        if (impact.end_date && moment(impact.end_date) <= moment()) {
          today_str = impact.end_date.split("T")[0]
        }

        if (tempStart !== null && impact.reduction && impact.frequency) {
          let lastYearOrStart = tempStart < lastYear ? lastYear.format('YYYY-MM-DD') : formattedStart
          let source = getBuildingInfo[typeDict[impact['type']]].find(e => e.channel_name && e.channel_name.trim() === impact['[source]'])
          if (!source) continue
          let applicableDates = GlobalFuncs.getApplicableDates(rangeStart, rangeEnd, impact.months, impact.days, impact.frequency, true, source, impact)
          let totalDates = GlobalFuncs.getApplicableDates(rangeStart, rangeEnd, impact.months, impact.days, impact.frequency, false, source, impact)
          let yearDates = GlobalFuncs.getApplicableDates(lastYearOrStart, today_str, impact.months, impact.days, impact.frequency, false, source, impact)

          switch (impact.type) {
            case 'kva':
              impact.reductionToDate = applicableDates.reduction
              impact.reductionTotal = totalDates.reduction
              impact.reductionYear = yearDates.reduction
              impact.priceToDate = applicableDates.cost
              impact.priceTotal = totalDates.cost
              impact.priceYear = yearDates.cost

              activity.kvaToDate += impact.reductionToDate
              activity.kvaTotal += impact.reductionTotal
              activity.kvaYear += impact.reductionYear

              activity.kvaPriceToDate += applicableDates.cost
              activity.kvaPriceYear += impact.priceYear

              break

            case 'kwh':
              impact.reductionToDate = applicableDates.reduction
              impact.reductionTotal = totalDates.reduction
              impact.reductionYear = yearDates.reduction
              impact.priceTotal = totalDates.cost
              impact.priceYear = yearDates.cost

              activity.kwhToDate += impact.reductionToDate
              activity.kwhTotal += impact.reductionTotal
              activity.kwhYear += impact.reductionYear

              activity.kwhPriceToDate += applicableDates.cost
              activity.kwhPriceYear += impact.priceYear

              activity.coToDate += applicableDates.co
              activity.coYear += yearDates.co

              break
            case 'gas':
              impact.reductionToDate = applicableDates.reduction
              impact.reductionTotal = totalDates.reduction
              impact.reductionYear = yearDates.reduction
              impact.priceTotal = totalDates.cost
              impact.priceYear = yearDates.cost

              activity.gasToDate += impact.reductionToDate
              activity.gasTotal += impact.reductionTotal
              activity.gasYear += impact.reductionYear
              activity.gasPriceToDate += applicableDates.cost
              activity.gasPriceYear += impact.priceYear
              activity.coToDate += applicableDates.co
              activity.coYear += yearDates.co

              break
            case 'water':
              impact.reductionToDate = applicableDates.reduction
              impact.reductionTotal = totalDates.reduction
              impact.reductionYear = yearDates.reduction
              impact.priceTotal = totalDates.cost
              impact.priceYear = yearDates.cost

              activity.waterToDate += impact.reductionToDate
              activity.waterTotal += impact.reductionTotal
              activity.waterYear += impact.reductionYear
              activity.waterPriceToDate += applicableDates.cost
              activity.waterPriceYear += impact.priceYear
              break
            default:
              break
          }
        }
      }
      activity.savings = activity.waterPriceToDate + activity.gasPriceToDate + activity.kwhPriceToDate + activity.kvaPriceToDate
      activity.savingsYear = activity.waterPriceYear + activity.gasPriceYear + activity.kwhPriceYear + activity.kvaPriceYear
      if (!activity.savings) activity.savings = 0
      if (!activity.savingsYear) activity.savingsYear = 0
    }
  },
  downloadExcel: (data, building = "Portfolio", type = "Activities") => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, type);
    let title = `Conservation Activities - ${building}`
    switch (type) {
      case "Devices":
        title = `Devices`
        break;
      case "Actuators":
        title = `Actuators`
        break;
      case "Bills":
        title = `Bills - ${building}`
        break;
      default:
        break;
    }
    XLSX.writeFile(workbook, `${title} - ${moment().format('D MMM YYYY')}.xlsx`);
  }
}

export default GlobalFuncs;